<div class="vm-menu-overlay" [ngStyle]="{'display': isOffcanvas && showmenu_Icon ? 'block' : 'none' }"></div>
<div class="vm-menu vm-menu--left vm-menu--fluid {{ menuStaticClass }} {{
    menuBindingClass
  }}"
     [style]="style"
     [ngClass]="{'vm-menu--fluid-offcanvas': isOffcanvas, 'vm-menu--fluid-open' : isOffcanvas && showmenu_Icon }">
  <ng-container *ngIf="isOffcanvas">
    <span class="vm-menu-call material-symbols-outlined vm-icon"
          (click)="showmenu_Icon = !showmenu_Icon; changeText()">{{ hambugerText }}</span>
  </ng-container>
  <div class="vm-menu__header" *ngIf="showHeader && menuHeaderVisible">
    <ng-container *ngTemplateOutlet="headerContent"> </ng-container>
  </div>
  <div class="vm-menu__content vm-menu__content--{{ expandable }}"
       [ngStyle]="{ overflow: expandable === 'flyout' ? 'inherit' : '' }">
    <ng-container *ngTemplateOutlet="bodyContent"> </ng-container>
  </div>

  <div class="vm-menu__footer" *ngIf="showFooter && menuFooterVisible">
    <ng-container *ngTemplateOutlet="footerContent"> </ng-container>
  </div>
</div>


<ng-template #headerContent>
  <ng-content select="[header]"></ng-content>
</ng-template>
<ng-template #bodyContent>
  <ng-content select="[body]"></ng-content>
</ng-template>
<ng-template #footerContent>
  <ng-content select="[footer]"></ng-content>
</ng-template>
